import { Injectable }   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class CaracteristicaPrevidenciaService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Caracteristica da Previdencia por id
     * @param id ID da Caracteristica da Previdencia
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "previdencia/caracteristica/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Caracteristica da Previdencia
     * @param id ID da Caracteristica da Previdencia
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "previdencia/caracteristica"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Caracteristica da Previdencia
     * @param id ID da Caracteristica da Previdencia
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "previdencia/caracteristica/search"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete da Caracteristica da Previdencia
     * @param id ID daCaracteristica da Previdencia
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "previdencia/caracteristica/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Caracteristica da Previdencia
     * @param params Json Caracteristica da Previdencia
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "previdencia/caracteristica", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Caracteristica da Previdencia
     * @param params Json Caracteristica da Previdencia
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "previdencia/caracteristica/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
